import styled from 'styled-components';

export const OurBoardMembersBox = styled.div`

    width: calc(25% - 23px);
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: column;
    background: #F7931E;
    border-radius: 15px;
    padding: 10px;
    overflow: hidden;
    box-shadow: 0px 5px 30px #0000001A;

    @media screen and (max-width: 991px){
        width: calc(50% - 10px);
        padding: 5px;
    }

    @media screen and (max-width: 480px){
        width: 100%;
    }

    &.advisory-board-box{
        background: #33A7AE;
    }

    // &.board-member-box{
    //     .member-name{
    //         color:#01606F;
    //     }
    // }

`;

export const OurBoardMembersImage = styled.div`
    width: 100%;
    min-height: 262px;
    border-radius: 10px;
    overflow: hidden;
    img{
        width: 100%;
        height: 100%;
        display: block;
        object-fit: cover;
        border-radius: 10px;
    }
`;

export const OurBoardMembersContent = styled.div`
    width: 100%;
    height: 115px;
    background: #FFFFFF;
    padding: 20px;
    text-align: center;
    border-radius: 10px;
    box-shadow: 0px 5px 30px #0000001A; 

    @media screen and (max-width: 991px){
        padding: 15px;
    }
`;

export const OurBoardMembersTitle = styled.div`
    color: #EA8B1C;
    font-size: 20px;
    font-family: 'Jost', sans-serif;
    font-weight: 700;
    line-height: 26px;
    margin-bottom: 5px;
`;

export const OurBoardMembersText = styled.div`
    color: #333333;
    font-size: 14px;
    font-family: 'Jost', sans-serif;
    font-weight: 400;
    line-height: 20px;
`;


